webpackJsonp([169966613400496],{

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(23);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _bloomer = __webpack_require__(16);
	
	var _Pageheader = __webpack_require__(26);
	
	var _Pageheader2 = _interopRequireDefault(_Pageheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AllotjamentsPage = function AllotjamentsPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Pageheader2.default, {
	      title: 'Allotjaments',
	      subtitle: 'Espais assignats als esplais per a dormir'
	    }),
	    _react2.default.createElement(
	      _bloomer.Section,
	      null,
	      _react2.default.createElement(
	        _bloomer.Content,
	        { className: 'has-text-justified' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'A continuaci\xF3 podreu trobar quins grups d\'edat i de quins esplais s\xF3n els que dormen als diferents equipaments designats com allotjament.'
	        )
	      ),
	      data.allContentfulEspais.edges.map(function (_ref2, id) {
	        var node = _ref2.node;
	        return _react2.default.createElement(
	          _bloomer.Box,
	          { key: node.id },
	          _react2.default.createElement(
	            _bloomer.Title,
	            { isSize: '5' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: node.slug },
	              node.nom
	            )
	          ),
	          _react2.default.createElement(
	            _bloomer.Content,
	            null,
	            _react2.default.createElement('div', {
	              className: 'has-text-justified',
	              dangerouslySetInnerHTML: {
	                __html: node.quiHiDorm.childMarkdownRemark.html
	              }
	            })
	          )
	        );
	      })
	    )
	  );
	};
	
	exports.default = AllotjamentsPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-allotjaments-js-d1322947f2bb30c33c4f.js